import React, { useState } from 'react';
import { IInvoicePaidPlan } from '../Interfaces/IInvoicePaidPlan';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material';
import { IInvoice } from '../Interfaces/IInvoice';

interface IProps {
  editInvoice: IInvoice;
  invPaidPlans: IInvoicePaidPlan[];
  setInvPaidPlans: Function;
  setIsOpen: Function;
}

export const InvoicePaidPlanAddDialog: React.FC<IProps> = ({
  editInvoice,
  invPaidPlans,
  setInvPaidPlans,
  setIsOpen,
}) => {
  const [amountPayments, setAmountPayments] = useState(3);
  const [timeInterations, setTimeInterations] = useState('m');
  const valuePerPlan = Number(editInvoice.Total) / amountPayments;

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleAdd = () => {
    const checkWeekend = (date: Date): Date => {
      const newDate = new Date(date); // Kopie erstellen, wenn du immutables Verhalten willst
      const day = newDate.getDay();
      if (day === 0) {
        newDate.setDate(newDate.getDate() + -2);
      }
      if (day === 6) {
        newDate.setDate(newDate.getDate() + -1);
      }
      return newDate;
    };

    const addPlanEntries: IInvoicePaidPlan[] = [];
    const baseDate = new Date();

    Array.from({ length: amountPayments }, (_, i) => i).map(i => {
      let currentDate = new Date();

      if (timeInterations === 'w') {
        const currentDay = baseDate.getDay();
        const daysUntilSunday = (7 - currentDay) % 7;
        currentDate.setMonth(baseDate.getMonth());
        currentDate.setDate(baseDate.getDate() + daysUntilSunday);
        currentDate = checkWeekend(currentDate);
      } else if (timeInterations === 'm') {
        currentDate = new Date(
          baseDate.getFullYear(),
          baseDate.getMonth() + 1,
          0,
          20
        );
        currentDate = checkWeekend(currentDate);
      } else if (timeInterations === 'q') {
        const currentMonth = baseDate.getMonth();
        const endMonthOfQuarter = Math.floor(currentMonth / 3) * 3 + 2;
        currentDate = new Date(
          baseDate.getFullYear(),
          endMonthOfQuarter + 1,
          0,
          20
        );
        currentDate = checkWeekend(currentDate);
      } else if (timeInterations === 'y') {
        currentDate = new Date(baseDate.getFullYear(), 11, 30, 20); // Dezember = 11 (0-basiert)
        currentDate = checkWeekend(currentDate);
      }

      addPlanEntries.push({
        idInvoice: editInvoice.idInvoice,
        idInvoicePaidPlan: -1 - i,
        PaidDate: currentDate.toISOString().split('T')[0],
        PaidValue: Math.round(valuePerPlan * 100) / 100,
        wasPaid: false,
      });

      if (timeInterations === 'w') {
        baseDate.setDate(baseDate.getDate() + 7);
      } else if (timeInterations === 'm') {
        baseDate.setMonth(baseDate.getMonth() + 1);
      } else if (timeInterations === 'q') {
        baseDate.setMonth(baseDate.getMonth() + 3);
      } else if (timeInterations === 'y') {
        baseDate.setFullYear(baseDate.getFullYear() + 1);
      }
    });
    setInvPaidPlans(addPlanEntries);
    handleClose();
  };

  return (
    <Dialog open onClose={handleClose} maxWidth='xs' fullWidth>
      <DialogTitle>Zahlungsplan hinzufügen</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={7}>
            <Typography sx={{ mt: 1 }}>Geplante Zahlungszyklen:</Typography>
          </Grid>
          <Grid item xs={5}>
            <TextField
              label='Zahlungszyklen'
              value={timeInterations}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setTimeInterations(event.target.value)
              }
              fullWidth
              size='small'
              select
            >
              {[
                { label: 'Wöchentlich', value: 'w' },
                { label: 'Monatlich', value: 'm' },
                { label: 'Quartal', value: 'q' },
                { label: 'Jährlich', value: 'y' },
              ].map(entry => (
                <MenuItem
                  key={`zahlungszyklen-${entry.value}`}
                  value={entry.value}
                >
                  {entry.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={7}>
            <Typography sx={{ mt: 1 }}>Geplante Raten:</Typography>
          </Grid>
          <Grid item xs={5}>
            <TextField
              label='Raten'
              value={amountPayments}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setAmountPayments(Number(event.target.value))
              }
              fullWidth
              size='small'
              select
            >
              {Array.from({ length: 9 }, (_, i) => i + 2).map(i => (
                <MenuItem key={`rate-${i}`} value={i}>
                  {i}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={7}>
            <Typography>Kalkulierte Raten:</Typography>
          </Grid>
          <Grid item xs={5}>
            <Typography>
              {valuePerPlan.toLocaleString('de-DE', {
                style: 'currency',
                currency: 'EUR',
              })}
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={handleClose}>
          Abbruch
        </Button>
        <Button variant='contained' onClick={handleAdd}>
          Hinzufügen
        </Button>
      </DialogActions>
    </Dialog>
  );
};
